import { PersonInfo } from "ui";

import useAdminImageMap from "../../hooks/useAdminImageMap";

interface AdminBadgeProps {
  adminId: string;
  adminName: string;
  compact?: boolean;
}

const AdminBadge = ({ adminId, adminName, compact }: AdminBadgeProps) => {
  const imageMap = useAdminImageMap();
  const image = imageMap.get(adminId);

  const size = compact ? 36 : 48;

  return (
    <PersonInfo
      image={image ?? undefined}
      personName={adminName || "—"}
      dimensions={{ width: size, height: size, borderRadius: "50%" }}
    />
  );
};

export default AdminBadge;
